import React from 'react';
import { motion } from 'framer-motion';
export function FloatingTestimonials() {
  return <div className="fixed bottom-4 left-4 z-40 hidden sm:block" data-id="element-82">
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} className="bg-white/10 backdrop-blur-md border border-white/20 p-4 rounded-2xl shadow-2xl max-w-xs" data-id="element-83">
        <div className="flex items-center gap-3 mb-2" data-id="element-84">
          <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center font-bold text-white" data-id="element-85">
            V
          </div>
          <div data-id="element-86">
            <p className="text-xs font-bold text-white" data-id="element-87">Valentina M.</p>
            <p className="text-[10px] text-yellow-300" data-id="element-88">
              Indumentaria · Buenos Aires
            </p>
          </div>
        </div>
        <p className="text-[11px] text-white/90 italic" data-id="element-89">
          "En la primera semana tuve 3 ventas por Instagram. El Script del Tomo
          5 me cambió todo."
        </p>
      </motion.div>
    </div>;
}